import { randomNumber } from '../../../../utilities'
import { OperationsConstants } from './operations.constants'
import { IOperationsAction, IOperationsState } from './operations.types'

export const initialOperationsState: IOperationsState = {
  stretcherChairMovingTo: false,
  jointCommissionTimeOut: false,
  rightPatient: false,
  rightProcedure: false,
  rightConsent: false,
  rightSiteSide: false,
  rightPosition: false,
  complete: false,
  safetyBrief: false,
  lastName: '',
  firstName: '',
  weight: null,
  weightUnit: null,
  hearingPrecautions: false,
  environmentalControls: false,
  safetyRestraints: false,
  seizurePrecautions: false,
  patientLoadedCold: false,
  patientLoadedHot: false,
  patientOffloadCold: false,
  patientOffloadHot: false,
  patientMonitoring: false,
  pediatricStretcherChair: false,
  pediatricSafetyRestraintDevice: false,
  babyPod: false,
  pediMate: false,
  patientPersonalProtectiveEquipment: false,
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Operations',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  jointCommissionTimeOutArray: [],
  isEkgImport: null,
  nemsisCode: null,
}

export function operationsReducer(
  state: IOperationsState = initialOperationsState,
  action: IOperationsAction
): IOperationsState {
  switch (action.type) {
    case OperationsConstants.SET_STRETCHER_CHAIR_MOVING_TO:
      return { ...state, stretcherChairMovingTo: action.stretcherChairMovingTo }
    case OperationsConstants.SET_JOINT_COMMISSION_TIME_OUT:
      return { ...state, jointCommissionTimeOut: action.jointCommissionTimeOut }
    case OperationsConstants.SET_RIGHT_PATIENT:
      return { ...state, rightPatient: action.rightPatient }
    case OperationsConstants.SET_RIGHT_PROCEDURE:
      return { ...state, rightProcedure: action.rightProcedure }
    case OperationsConstants.SET_RIGHT_CONSENT:
      return { ...state, rightConsent: action.rightConsent }
    case OperationsConstants.SET_RIGHT_SITE_SIDE:
      return { ...state, rightSiteSide: action.rightSiteSide }
    case OperationsConstants.SET_RIGHT_POSITION:
      return { ...state, rightPosition: action.rightPosition }
    case OperationsConstants.SET_COMPLETE:
      return { ...state, complete: action.complete }
    case OperationsConstants.SET_SAFETY_BRIEF:
      return { ...state, safetyBrief: action.safetyBrief, firstName: '', lastName: '', weight: '' }
    case OperationsConstants.SET_LAST_NAME:
      return { ...state, lastName: action.lastName }
    case OperationsConstants.SET_FIRST_NAME:
      return { ...state, firstName: action.firstName }
    case OperationsConstants.SET_WEIGHT:
      return { ...state, weight: action.weight }
    case OperationsConstants.SET_WEIGHT_UNIT:
      return { ...state, weightUnit: action.weightUnit }
    case OperationsConstants.SET_HEARING_PRECAUTIONS:
      return { ...state, hearingPrecautions: action.hearingPrecautions }
    case OperationsConstants.SET_ENVIRONMENTAL_CONTROLS:
      return { ...state, environmentalControls: action.environmentalControls }
    case OperationsConstants.SET_SAFETY_RESTRAINTS:
      return { ...state, safetyRestraints: action.safetyRestraints }
    case OperationsConstants.SET_SEIZURE_PRECAUTIONS:
      return { ...state, seizurePrecautions: action.seizurePrecautions }
    case OperationsConstants.SET_PATIENT_LOADED_COLD:
      return { ...state, patientLoadedCold: action.patientLoadedCold }
    case OperationsConstants.SET_PATIENT_LOADED_HOT:
      return { ...state, patientLoadedHot: action.patientLoadedHot }
    case OperationsConstants.SET_PATIENT_OFFLOAD_COLD:
      return { ...state, patientOffloadCold: action.patientOffloadCold }
    case OperationsConstants.SET_PATIENT_OFFLOAD_HOT:
      return { ...state, patientOffloadHot: action.patientOffloadHot }
    case OperationsConstants.SET_PATIENT_MONITORING:
      return { ...state, patientMonitoring: action.patientMonitoring }
    case OperationsConstants.SET_PEDIATRIC_STRETCHER_CHAIR:
      return { ...state, pediatricStretcherChair: action.pediatricStretcherChair }
    case OperationsConstants.SET_PEDIATRIC_SAFETY_RESTRAINT_DEVICE:
      return { ...state, pediatricSafetyRestraintDevice: action.pediatricSafetyRestraintDevice }
    case OperationsConstants.SET_BABYPOD:
      return { ...state, babyPod: action.babyPod }
    case OperationsConstants.SET_PEDIMATE:
      return { ...state, pediMate: action.pediMate }
    case OperationsConstants.SET_PATIENT_PERSONAL_PROTECTIVE_EQUIPMENT:
      return { ...state, patientPersonalProtectiveEquipment: action.patientPersonalProtectiveEquipment }
    case OperationsConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case OperationsConstants.SET_DATE:
      return { ...state, date: action.date }
    case OperationsConstants.SET_TIME:
      return { ...state, time: action.time }
    case OperationsConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case OperationsConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case OperationsConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case OperationsConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case OperationsConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case OperationsConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case OperationsConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case OperationsConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case OperationsConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case OperationsConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case OperationsConstants.SET_STATE:
      return { ...action.operationsState, updateInputRows: true }
    case OperationsConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case OperationsConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case OperationsConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case OperationsConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case OperationsConstants.SET_JOINT_COMMISSION_TIMEOUT_ARRAY:
      return { ...state, jointCommissionTimeOutArray: action.jointCommissionTimeOutArray }
    case OperationsConstants.RESET_STATE:
      return {
        stretcherChairMovingTo: false,
        jointCommissionTimeOut: false,
        rightPatient: false,
        rightProcedure: false,
        rightConsent: false,
        rightSiteSide: false,
        rightPosition: false,
        complete: false,
        safetyBrief: false,
        lastName: '',
        firstName: '',
        weight: '',
        weightUnit: null,
        hearingPrecautions: false,
        environmentalControls: false,
        safetyRestraints: false,
        seizurePrecautions: false,
        patientLoadedCold: false,
        patientLoadedHot: false,
        patientOffloadCold: false,
        patientOffloadHot: false,
        patientMonitoring: false,
        pediatricStretcherChair: false,
        pediatricSafetyRestraintDevice: false,
        babyPod: false,
        pediMate: false,
        patientPersonalProtectiveEquipment: false,
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Operations',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        jointCommissionTimeOutArray: [],
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
